import ConfirmationRoot from "../../../routes/confirmation/v3/pages/BookAppointment/routes/confirmation/ConfirmationRoot.js";
import WhereRoot from "../../../routes/default/v3/pages/BookAppointment/routes/default/WhereRoot.js";
import WhatRoot from "../../../routes/what/v3/pages/BookAppointment/routes/what/WhatRoot.js";
import WhenRoot from "../../../routes/when/v3/pages/BookAppointment/routes/when/WhenRoot.js";
import WhoRoot from "../../../routes/who/v3/pages/BookAppointment/routes/who/WhoRoot.js";
const routeMap = {
  "": WhereRoot,
  where: WhereRoot,
  what: WhatRoot,
  when: WhenRoot,
  who: WhoRoot,
  confirmation: ConfirmationRoot
};
export {
  routeMap
};
//# sourceMappingURL=route-map.js.map
